import { title } from "process";

export type StepKey = keyof typeof stepDescriptionsIt.steps;

export const stepDescriptionsIt = {
    steps: {
        lead: {
            title: 'lead',
            description: 'Il tuo nome completo ed email ci aiuta a personalizzare la tua esperienza.'
        },
        full_name: {
            title: 'full_name',
            description: 'Il tuo nome completo ci aiuta a personalizzare la tua esperienza.'
        },
        birthday: {
            title: 'birthday',
            description: 'La tua data di nascita è fondamentale per fornirti consigli adatti alla tua età.'
        },
        email: {
            title: 'email',
            description: 'Il tuo indirizzo email è importante per poterti contattare con informazioni utili.'
        },
        domicile: {
            title: 'domicile',
            description: 'Conoscere la tua provincia di domicilio ci aiuta a offrirti opportunità locali.'
        },
        italian_residence: {
            title: 'italian_residence',
            description: 'Saper se risiedi in Italia è necessario per offrirti servizi specifici.'
        },
        is_know_what_study: {
            title: 'is_know_what_study',
            description: 'Saper se sai già cosa vuoi studiare',
        },
        latest_title: {
            title: 'latest_title',
            description: 'Conoscere il tuo percorso scolastico ci aiuta a capire le tue esigenze educative.'
        },
        study_where_hs: {
            title: 'study_where_hs',
            description: 'Sapere quale scuola hai frequentato ci aiuta a profilarti accuratamente.'
        },
        study_where_not_hs: {
            title: 'study_where_hs',
            description: 'Sapere quale scuola hai frequentato ci aiuta a profilarti accuratamente.'
        },
        is_hs_done: {
            title: 'is_hs_done',
            description: 'Conoscere il tuo percorso scolastico ci aiuta a capire le tue esigenze educative.'
        },
        hs_school: {
            title: 'hs_school',
            description: 'Sapere quale scuola hai frequentato ci aiuta a profilarti accuratamente.'
        },
        hs_school_enrolled: {
            title: 'hs_school_enrolled',
            description: 'Sapere quale scuola hai frequentato ci aiuta a profilarti accuratamente.'
        },
        hs_school_course_type: {
            title: 'hs_school_course_type',
            description: 'Il tipo di corso che hai seguito ci aiuta a definire meglio il tuo profilo accademico.'
        },
        hs_school_course_type_enrolled: {
            title: 'hs_school_course_type_enrolled',
            description: 'Il tipo di corso che hai seguito ci aiuta a definire meglio il tuo profilo accademico.'
        },
        hs_year_at: {
            title: 'hs_year_at',
            description: 'Il voto del tuo diploma è importante per offrirti le giuste opportunità educative.'
        },
        hs_school_graduation_year: {
            title: 'hs_school_graduation_year',
            description: 'Il voto del tuo diploma è importante per offrirti le giuste opportunità educative.'
        },
        hs_school_grade: {
            title: 'hs_school_grade',
            description: 'Il voto del tuo diploma è importante per offrirti le giuste opportunità educative.'
        },
        has_post_hs_titles: {
            title: 'has_post_hs_titles',
            description: 'Conoscere eventuali altri titoli accademici ci aiuta a capire meglio il tuo percorso.'
        },
        is_enrolled_post_hs_school: {
            title: 'is_enrolled_post_hs_school',
            description: 'Sapere se sei iscritto ad altri istituti ci aiuta a profilarti accuratamente.'
        },
        post_hs_school_title_type_completed: {
            title: 'post_hs_school_title_type_completed',
            description: 'Sapere se sei iscritto ad altri istituti ci aiuta a profilarti accuratamente.'
        },
        post_hs_school_title_school_completed: {
            title: 'post_hs_school_title_school_completed',
            description: 'Sapere se sei iscritto ad altri istituti ci aiuta a profilarti accuratamente.'
        },
        post_hs_school_course_completed: {
            title: 'post_hs_school_course_completed',
            description: 'Sapere se sei iscritto ad altri istituti ci aiuta a profilarti accuratamente.'
        },
        post_hs_school_year_at_completed: {
            title: 'post_hs_school_year_at_completed',
            description: 'Sapere se sei iscritto ad altri istituti ci aiuta a profilarti accuratamente.'
        },
        post_hs_school_grade_completed: {
            title: 'post_hs_school_grade_completed',
            description: 'Sapere se sei iscritto ad altri istituti ci aiuta a profilarti accuratamente.'
        },
        post_hs_school_title_type_enrolled: {
            title: 'post_hs_school_title_type_enrolled',
            description: 'Sapere se sei iscritto ad altri istituti ci aiuta a profilarti accuratamente.'
        },
        post_hs_school_title_school_enrolled: {
            title: 'post_hs_school_title_school_enrolled',
            description: 'Sapere se sei iscritto ad altri istituti ci aiuta a profilarti accuratamente.'
        },
        post_hs_school_course_enrolled: {
            title: 'post_hs_school_course_enrolled',
            description: 'Sapere se sei iscritto ad altri istituti ci aiuta a profilarti accuratamente.'
        },
        post_hs_school_year_at_enrolled: {
            title: 'post_hs_school_year_at_enrolled',
            description: 'Sapere se sei iscritto ad altri istituti ci aiuta a profilarti accuratamente.'
        },
        study_area: {
            title: 'study_area',
            description: 'Conoscere i tuoi interessi ci permette di offrirti consigli personalizzati.'
        },
        interests_open: {
            title: 'interests_open',
            description: 'Conoscere i tuoi interessi ci permette di offrirti consigli personalizzati.'
        },
        future_step_work_open: {
            title: 'future_step_work_open',
            description: 'Conoscere le tue aspirazioni lavorative ci aiuta a fornirti i consigli più adatti.'
        },
        interests: {
            title: 'interests',
            description: 'Conoscere i tuoi interessi ci permette di offrirti consigli personalizzati.'
        },
        sub_interests: {
            title: 'sub_interests',
            description: 'Sapere i tuoi interessi ci aiuta a offrirti un orientamento più dettagliato.'
        },
        future_step_school_type: {
            title: 'future_step_school_type',
            description: 'Conoscere la tua preferenza tra università e ITS ci aiuta a orientarti meglio.'
        },
        future_step_where: {
            title: 'future_step_where',
            description: 'Indicare dove vorresti studiare ci aiuta a offrirti le giuste opportunità.'
        },
        future_step_work: {
            title: 'future_step_work',
            description: 'Conoscere le tue aspirazioni lavorative ci aiuta a fornirti i consigli più adatti.'
        }
    }
};

export const stepDescriptionsEn = {
    steps: {
        lead: {
            title: 'lead',
            description: 'Il tuo nome completo ed email ci aiuta a personalizzare la tua esperienza.'
        },
        full_name: {
            title: 'full_name',
            description: 'Il tuo nome completo ci aiuta a personalizzare la tua esperienza.'
        },
        birthday: {
            title: 'birthday',
            description: 'La tua data di nascita è fondamentale per fornirti consigli adatti alla tua età.'
        },
        email: {
            title: 'email',
            description: 'Il tuo indirizzo email è importante per poterti contattare con informazioni utili.'
        },
        domicile: {
            title: 'domicile',
            description: 'Conoscere la tua provincia di domicilio ci aiuta a offrirti opportunità locali.'
        },
        italian_residence: {
            title: 'italian_residence',
            description: 'Saper se risiedi in Italia è necessario per offrirti servizi specifici.'
        },
        is_know_what_study: {
            title: 'is_know_what_study',
            description: 'Saper se sai già cosa vuoi studiare',
        },
        latest_title: {
            title: 'latest_title',
            description: 'Conoscere il tuo percorso scolastico ci aiuta a capire le tue esigenze educative.'
        },
        study_where_hs: {
            title: 'study_where_hs',
            description: 'Sapere quale scuola hai frequentato ci aiuta a profilarti accuratamente.'
        },
        study_where_not_hs: {
            title: 'study_where_hs',
            description: 'Sapere quale scuola hai frequentato ci aiuta a profilarti accuratamente.'
        },
        is_hs_done: {
            title: 'is_hs_done',
            description: 'Conoscere il tuo percorso scolastico ci aiuta a capire le tue esigenze educative.'
        },
        hs_school: {
            title: 'hs_school',
            description: 'Sapere quale scuola hai frequentato ci aiuta a profilarti accuratamente.'
        },
        hs_school_enrolled: {
            title: 'hs_school_enrolled',
            description: 'Sapere quale scuola hai frequentato ci aiuta a profilarti accuratamente.'
        },
        hs_school_course_type: {
            title: 'hs_school_course_type',
            description: 'Il tipo di corso che hai seguito ci aiuta a definire meglio il tuo profilo accademico.'
        },
        hs_school_course_type_enrolled: {
            title: 'hs_school_course_type_enrolled',
            description: 'Il tipo di corso che hai seguito ci aiuta a definire meglio il tuo profilo accademico.'
        },
        hs_year_at: {
            title: 'hs_year_at',
            description: 'Il voto del tuo diploma è importante per offrirti le giuste opportunità educative.'
        },
        hs_school_graduation_year: {
            title: 'hs_school_graduation_year',
            description: 'Il voto del tuo diploma è importante per offrirti le giuste opportunità educative.'
        },
        hs_school_grade: {
            title: 'hs_school_grade',
            description: 'Il voto del tuo diploma è importante per offrirti le giuste opportunità educative.'
        },
        has_post_hs_titles: {
            title: 'has_post_hs_titles',
            description: 'Conoscere eventuali altri titoli accademici ci aiuta a capire meglio il tuo percorso.'
        },
        is_enrolled_post_hs_school: {
            title: 'is_enrolled_post_hs_school',
            description: 'Sapere se sei iscritto ad altri istituti ci aiuta a profilarti accuratamente.'
        },
        post_hs_school_title_type_completed: {
            title: 'post_hs_school_title_type_completed',
            description: 'Sapere se sei iscritto ad altri istituti ci aiuta a profilarti accuratamente.'
        },
        post_hs_school_title_school_completed: {
            title: 'post_hs_school_title_school_completed',
            description: 'Sapere se sei iscritto ad altri istituti ci aiuta a profilarti accuratamente.'
        },
        post_hs_school_course_completed: {
            title: 'post_hs_school_course_completed',
            description: 'Sapere se sei iscritto ad altri istituti ci aiuta a profilarti accuratamente.'
        },
        post_hs_school_year_at_completed: {
            title: 'post_hs_school_year_at_completed',
            description: 'Sapere se sei iscritto ad altri istituti ci aiuta a profilarti accuratamente.'
        },
        post_hs_school_grade_completed: {
            title: 'post_hs_school_grade_completed',
            description: 'Sapere se sei iscritto ad altri istituti ci aiuta a profilarti accuratamente.'
        },
        post_hs_school_title_type_enrolled: {
            title: 'post_hs_school_title_type_enrolled',
            description: 'Sapere se sei iscritto ad altri istituti ci aiuta a profilarti accuratamente.'
        },
        post_hs_school_title_school_enrolled: {
            title: 'post_hs_school_title_school_enrolled',
            description: 'Sapere se sei iscritto ad altri istituti ci aiuta a profilarti accuratamente.'
        },
        post_hs_school_course_enrolled: {
            title: 'post_hs_school_course_enrolled',
            description: 'Sapere se sei iscritto ad altri istituti ci aiuta a profilarti accuratamente.'
        },
        post_hs_school_year_at_enrolled: {
            title: 'post_hs_school_year_at_enrolled',
            description: 'Sapere se sei iscritto ad altri istituti ci aiuta a profilarti accuratamente.'
        },
        study_area: {
            title: 'study_area',
            description: 'Conoscere i tuoi interessi ci permette di offrirti consigli personalizzati.'
        },
        interests_open: {
            title: 'interests_open',
            description: 'Conoscere i tuoi interessi ci permette di offrirti consigli personalizzati.'
        },
        future_step_work_open: {
            title: 'future_step_work_open',
            description: 'Conoscere le tue aspirazioni lavorative ci aiuta a fornirti i consigli più adatti.'
        },
        interests: {
            title: 'interests',
            description: 'Conoscere i tuoi interessi ci permette di offrirti consigli personalizzati.'
        },
        sub_interests: {
            title: 'sub_interests',
            description: 'Sapere i tuoi interessi ci aiuta a offrirti un orientamento più dettagliato.'
        },
        future_step_school_type: {
            title: 'future_step_school_type',
            description: 'Conoscere la tua preferenza tra università e ITS ci aiuta a orientarti meglio.'
        },
        future_step_where: {
            title: 'future_step_where',
            description: 'Indicare dove vorresti studiare ci aiuta a offrirti le giuste opportunità.'
        },
        future_step_work: {
            title: 'future_step_work',
            description: 'Conoscere le tue aspirazioni lavorative ci aiuta a fornirti i consigli più adatti.'
        }
    }
};

// export const stepDescriptionsEn = {
//     steps: {
//         full_name: {
//             title: 'full_name',
//             description: 'Your full name helps us personalize your experience.',
//             description2: 'We need your name and surname to get to know you better.',
//             description3: 'Tell us your name so we can get to know you!'
//         },
//         birthday: {
//             title: 'birthday',
//             description: 'Your birthdate is crucial for providing age-appropriate advice.',
//             description2: 'To help you better, we need to know when you were born.',
//             description3: 'When is your birthday? This helps us tailor our advice to you!'
//         },
//         email: {
//             title: 'email',
//             description: 'Your email address is important for future communications.',
//             description2: 'Enter your email so we can keep you updated.',
//             description3: 'What\'s your email? We\'ll send you all the updates!'
//         },
//         domicile: {
//             title: 'domicile',
//             description: 'Knowing your domicile province helps us offer local opportunities.',
//             description2: 'Tell us where you live to suggest the best options near you.',
//             description3: 'Where do you live? This helps us give better advice!'
//         },
//         italian_residence: {
//             title: 'italian_residence',
//             description: 'Knowing if you reside in Italy is necessary to offer specific services.',
//             description2: 'Do you live in Italy? This helps us understand what opportunities to suggest.',
//             description3: 'Do you live in Italy? It\'s an important piece of info for us.'
//         },
//         is_hs_done: {
//             title: 'is_hs_done',
//             description: 'Knowing your educational background helps us understand your needs.',
//             description2: 'Have you finished high school? This is useful for our algorithm.',
//             description3: 'Did you graduate? We need this to advise you better!'
//         },
//         hs_school: {
//             title: 'hs_school',
//             description: 'Knowing which high school you attended helps us profile you accurately.',
//             description2: 'Tell us your high school to better understand your background.',
//             description3: 'Which high school did you attend? This helps us learn more about you.'
//         },
//         hs_school_enrolled: {
//             title: 'hs_school_enrolled',
//             description: 'Knowing which high school you attended helps us profile you accurately.',
//             description2: 'Tell us your high school to better understand your background.',
//             description3: 'Which high school did you attend? This helps us learn more about you.'
//         },
//         hs_school_course_type: {
//             title: 'hs_school_course_type',
//             description: 'The type of course you attended helps us better define your academic profile.',
//             description2: 'Select the type of course you attended in high school.',
//             description3: 'What type of course did you take in high school?'
//         },
//         hs_school_grade: {
//             title: 'hs_school_grade',
//             description: 'Your diploma grade is important for offering the right educational opportunities.',
//             description2: 'What was your diploma grade? This helps us know you better.',
//             description3: 'What grade did you get on your diploma? We need this to advise you better!'
//         },
//         has_post_hs_titles: {
//             title: 'has_post_hs_titles',
//             description: 'Knowing any additional titles helps us understand your academic journey.',
//             description2: 'Have you obtained any titles after high school? This helps us understand your level.',
//             description3: 'Did you get any other titles after high school?'
//         },
//         is_enrolled_post_hs_school: {
//             title: 'is_enrolled_post_hs_school',
//             description: 'Knowing if you are enrolled in post-high school institutions helps us profile you accurately.',
//             description2: 'Are you enrolled in an ITS or university? This is useful for our algorithm.',
//             description3: 'Did you enroll in a school after high school?'
//         },
//         interests: {
//             title: 'interests',
//             description: 'Knowing your interests allows us to offer personalized advice.',
//             description2: 'What are your academic interests? This helps us get to know you better.',
//             description3: 'What are you interested in studying? Tell us your interests!'
//         },
//         sub_interests: {
//             title: 'sub_interests',
//             description: 'Knowing your sub-interests helps us offer more detailed guidance.',
//             description2: 'What are your academic sub-interests? This helps us get to know you better.',
//             description3: 'Do you have any sub-interests? Let us know!'
//         },
//         future_step_school_type: {
//             title: 'future_step_school_type',
//             description: 'Knowing your preference between university and ITS helps us guide you better.',
//             description2: 'Do you prefer a university or an ITS path? This helps us get to know you better.',
//             description3: 'Do you want to go to university or ITS? Let us know!'
//         },
//         future_step_where: {
//             title: 'future_step_where',
//             description: 'Knowing where you\'d like to study helps us offer the right opportunities.',
//             description2: 'In which city do you want to study? This helps us get to know you better.',
//             description3: 'Where would you like to study? Tell us your favorite city!'
//         },
//         future_step_work: {
//             title: 'future_step_work',
//             description: 'Knowing your career aspirations helps us provide the most suitable advice.',
//             description2: 'What job would you like after your studies? This helps us get to know you better.',
//             description3: 'What job do you dream of doing once you finish studying? Let us know!'
//         }
//     }
// };



